<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>

  <main class="cc-main" aria-label="Career pages">
    <!-- HEADER -->
    <div class="cc-header">
      <div>
        <h1 class="cc-title">Career Pages</h1>
        <p class="cc-subtitle" aria-live="polite">
          {{ publishedCount }} published · {{ draftCount }} drafts
        </p>
      </div>
      <button
        mat-flat-button
        class="cc-new-btn"
        routerLink="/counselors/careers/edit"
        aria-label="Create new career page"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        New career
      </button>
    </div>

    <!-- SEARCH + FILTERS -->
    <div class="cc-toolbar" role="search" aria-label="Search and filter careers">
      <mat-form-field class="cc-search-field" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Search careers..."
          [(ngModel)]="searchQuery"
          aria-label="Search careers"
          [attr.data-testid]="'search-careers-input'"
        />
      </mat-form-field>

      <mat-chip-listbox
        class="cc-chips"
        [(ngModel)]="activeFilter"
        hideSingleSelectionIndicator
        aria-label="Filter careers by status"
        data-testid="career-filter-listbox"
      >
        <mat-chip-option
          *ngFor="let f of filters"
          [value]="f"
          [selected]="activeFilter === f"
          (click)="activeFilter = f"
          [attr.data-testid]="'career-filter-' + f.toLowerCase()"
        >
          {{ f }}
        </mat-chip-option>
      </mat-chip-listbox>
    </div>

    <!-- CARD GRID -->
    @if (filteredCareers.length) {
      <div class="cc-grid" role="list" aria-label="Career pages">
        @for (career of filteredCareers; track career.id) {
          <mat-card
            class="cc-card"
            appearance="outlined"
            role="listitem"
            (click)="openPage(career)"
            tabindex="0"
            (keydown.enter)="openPage(career)"
            (keydown.space)="openPage(career)"
            [attr.aria-label]="
              career.name +
              ', ' +
              careerTypes().find((c) => c.id === career.career_type_id)?.name +
              ', ' +
              career.status
            "
          >
            <mat-card-content>
              <div class="cc-card-top">
                <div class="cc-card-emoji" aria-hidden="true">{{ career.icon }}</div>
                <span
                  class="cc-status-dot"
                  [class.published]="career.status === 'Published'"
                  [attr.aria-label]="career.status"
                  [matTooltip]="career.status"
                >
                </span>
              </div>
              <div class="cc-card-body">
                <div class="cc-card-title">{{ career.name }}</div>
                <div class="cc-card-category">
                  {{ careerTypes().find((c) => c.id === career.career_type_id)?.name }}
                </div>
              </div>
              <div class="cc-card-meta">
                <span class="cc-meta-item">
                  <mat-icon class="cc-meta-icon" aria-hidden="true">schedule</mat-icon>
                  Updated {{ career.updatedAt | date: 'mediumDate' }}
                </span>
              </div>
              <mat-divider class="cc-divider" aria-hidden="true"></mat-divider>
              <div class="cc-card-footer">
                <span
                  class="cc-badge"
                  aria-hidden="true"
                  [class.published]="career.status === 'Published'"
                >
                  {{ career.status }}
                </span>
                <div class="cc-card-actions">
                  <button
                    mat-button
                    class="cc-action-btn"
                    [attr.aria-label]="'Edit ' + career.name"
                    (click)="updateCareer(career); $event.stopPropagation()"
                  >
                    Edit
                  </button>
                  <button
                    mat-button
                    class="cc-action-btn danger"
                    [attr.aria-label]="'Delete ' + career.name"
                    (click)="deleteCareer(career); $event.stopPropagation()"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }

    <!-- EMPTY STATE -->
    @if (filteredCareers.length === 0) {
      <div class="cc-empty" role="status">
        <div class="cc-empty-icon" aria-hidden="true">💼</div>
        <div class="cc-empty-title">No careers yet</div>
        <div class="cc-empty-sub">Create your first career page for students to explore.</div>
        <button
          mat-flat-button
          class="cc-new-btn"
          routerLink="/counselors/careers/edit"
          aria-label="Create new career page"
        >
          <mat-icon aria-hidden="true">add</mat-icon>
          New career
        </button>
      </div>
    }
  </main>
</div>
